export const formatCurrency = (n) => '₹' + Number(n || 0).toLocaleString('en-IN');

export const formatDate = (d, opts) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-IN', opts);
};

export const formatDateTime = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleString('en-IN');
};

export const safeNumber = (n, fallback = 0) => {
  const v = Number(n);
  return Number.isFinite(v) ? v : fallback;
};
